import React, { useState } from 'react';
import type { SetStateAction } from 'react';
import { SwishPanel } from '../components';
import type { AllIconType } from '../util/types';

type InitialPropsType = {
  title?: string,
  icon?: AllIconType,
  alwaysOnTop?: boolean,
  disableMaskClick?: boolean
} & Record<string, any>;

/**
 * To use it like:
 *
 * const [ swishPanel, toggle, setProps ] = useSwishPanel((props: any) => (
 *  <div>content</div>
 * ), {}, () => alert('on close!'))
 *
 * @param Content Component content of the modal.
 * @param initialProps Any initial props you want to set to the modal.
 * @param onClose Function to be called when click on mask/x button happens.
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export const useSwishPanel = (Content: any, initialProps: InitialPropsType = {}, onClose = () => {/* Does nothing */}): [React.ReactElement, (open: boolean) => void, (props: SetStateAction<InitialPropsType>) => void, boolean] => {
  const [ isOpen, setOpen ] = useState(false);
  const [ props, setProps ] = useState<InitialPropsType>(initialProps);
  const toggle = (isOpen?: boolean) => setOpen((prev) => null != isOpen ? isOpen : !prev);

  const component = (
    <SwishPanel
      open={isOpen}
      onClose={onClose}
      toggle={toggle}
      alwaysOnTop={props?.alwaysOnTop}
      disableMaskClick={props?.disableMaskClick}
    >
      <Content toggle={toggle} {...props} />
    </SwishPanel>
  );

  return [ component, toggle, setProps, isOpen ];
};
